import { runFunction } from "../../http";

export const sendChatNotification = async (data: {}): Promise<void> => {
  await runFunction("sendChatNotification", data, {
    requireUser: true,
    error: false,
  });
};
